import {WinFieldView} from 'src/winfield/WinFieldView';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {GameViews} from 'src/GameViews';
import {GameAvalancheReelsEvents} from 'src/avalanche/GameAvalancheReelsEvents';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {GameBackgroundModule} from 'src/background/GameBackgroundModule';

export class WinFieldModule extends Module<WinFieldView> {
	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		this.setView(GameViews.WIN_FIELD_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.onWinHighlightStarted);
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);

		this.on(WinPresentationEvents.INITIAL_ANIMATION_STARTED, this.onInitialWinPresentationStarted);

		this.on(StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
		this.on(GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
	}

	protected onFreeSpinsOutroStarted(): void {
		this.view.hide();
	}

	protected onFreeSpinsIntroStarted(): void {
		this.view.hide();
	}

	protected onFreeSpinsIntroFinished(): void {
		this.view.show();
	}

	protected onFreeSpinsOutroFinished(): void {
		this.view.show();
	}

	protected onStartScreenIntroStarted(): void {
		this.view.setReelsContainerAlphaToZero();
	}

	protected onTransitionAnimationStarted(): void {
		this.view.playReelContainerTransition();
	}

	protected onInitialWinPresentationStarted(): void {
		this.view.fadeOutWinValue();
	}

	protected onWinHighlightStarted(eventID: string, totalTimer: number): void {
		const logic: GameRecodeLogic = this.logic as GameRecodeLogic;

		this.view.countup(logic.getNextAvalancheRunningTotalInCents(), totalTimer);
	}

	protected onSpinStarted(): void {
		this.view.zeroWin();
		this.view.fadeInWinValue();
	}
}



// WEBPACK FOOTER //
// ./src/winfield/WinFieldModule.ts